<template>
  <div id="treeWrap">
    <div style="padding: 10px" v-if="sousuo">
      <Input
        v-model="keyword"
        placeholder="搜索单位"
        @on-search="searchGroup"
        search
      />
    </div>

    <div
      :class="'treeHeight' + height"
      class="treeHeight gundongtiao"
      id="monitorTreeTop"
    >
      <Tree
        :data="treeData"
        ref="tree"
        :show-checkbox="isMore"
        :check-strictly="false"
        :check-directly="false"
        select-node
        @on-select-change="selectFleet"
        @on-check-change="selectAlot"
      ></Tree>
    </div>
    <div v-if="zsgc" style="margin-top: 10px; padding: 0 15px">
      <Button size="small" type="primary" @click="clickOpenGroup" long
        >新增一级单位</Button
      >
    </div>
    <Row id="treeBtn" v-if="btn != undefined">
      <Col span="12"
        ><Button
          long
          type="primary"
          :disabled="grouopArr.length == 0"
          @click="queding"
          >确定</Button
        ></Col
      >
      <Col span="12"><Button long>取消</Button></Col>
    </Row>
    <Modal
      v-model="openGroup"
      :title="groupTitle"
      :mask-closable="false"
      footer-hide
      width="420"
      height="100"
    >
      <Form ref="item" :model="userGroup" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="单位名称" prop="name">
              <Input v-model="userGroup.name" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="24" v-if="!isAdd">
            <FormItem label="创建人" prop="owner">
              {{userGroup.owner}}
            </FormItem>
          </Col>
        </Row>

        <Row type="flex" justify="end">
          <Col span="12">
            <div class="btn-wrap">
              <Button @click="cliclCancelBtn">取消</Button>
              <Button type="primary" @click="addUpdate">提交</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["zsgc", "isMore", "btn", "groupIdList", "sousuo", "height"],
  data() {
    return {
      keyword: "",
      openGroup: false,
      treeData: [],
      isAdd: true,
      groupTitle: "",
      ddd: 100,
      userGroup: {
        name: "",
        parentId: "",
        owner:'暂无'
      },
      grouopArr: [], //选择到的组，点击确定用到
    };
  },
  methods: {
    getGroupList() {
      axios({
        method: "post",
        url: "/userGroup/tree",
        data: {},
      }).then((res) => {
        this.data = [];
        var that = this;
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        }
        var data = res.data.data;
        if (data.length == 0) {
          this.$emit("fleetObj");
          return;
        }
        /* data = data.filter(function (item) {
          return item.parentId == null || item.parentId.length == 0;
        }); */
        function treedata(a) {
          let d = a.map((r) => {
            if (r.childGroupList.length > 0) {
              return {
                title: r.name,
                parentId: r.parentId,
                groupId: r.groupId,
                name: r.name,
                expand: false,
                checked: false,
                selected: false,
                children: treedata(r.childGroupList),
                render(h) {
                  return h(
                    "div",
                    {
                      class: "treeitem",
                      attrs: {
                        id: "box" + r.groupId,
                      },
                    },
                    [
                      h("span", r.name),
                      // h("span", "(" + 123 + "台)"),
                      h(
                        "span",
                        {
                          class: "control",
                          style: {
                            display: that.zsgc ? "inline-block" : "none",
                          },
                        },
                        [
                          h("Icon", {
                            props: { type: "md-add" },
                            attrs: {
                              title: "新增下级单位",
                            },
                            on: {
                              click: (e) => {
                                that.clickAdd(r);
                                e.stopPropagation();
                              },
                            },
                          }),
                          h("Icon", {
                            props: { type: "md-checkmark-circle-outline" },
                            attrs: {
                              title: "编辑",
                            },
                            on: {
                              click: (e) => {
                                that.clickUpdate(r);
                                e.stopPropagation();
                              },
                            },
                          }),
                          h("Icon", {
                            props: { type: "md-close" },
                            attrs: {
                              title: "删除",
                            },
                            on: {
                              click: (e) => {
                                that.delFleet(r);
                                e.stopPropagation();
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  );
                },
              };
            } else {
              return {
                title: r.name,
                parentId: r.parentId,
                groupId: r.groupId,
                name: r.name,
                expand: false,
                checked: false,
                selected: false,
                render(h) {
                  return h(
                    "div",
                    {
                      class: "treeitem",
                      attrs: {
                        id: "box" + r.groupId,
                      },
                    },
                    [
                      h("span", r.name),
                      // h("span", "(" + 123 + "台)"),
                      h(
                        "span",
                        {
                          class: "control",
                          style: {
                            display: that.zsgc ? "inline-block" : "none",
                          },
                        },
                        [
                          h("Icon", {
                            props: { type: "md-add" },
                            attrs: {
                              title: "新增下级单位",
                            },
                            on: {
                              click: (e) => {
                                that.clickAdd(r);
                                e.stopPropagation();
                              },
                            },
                          }),
                          h("Icon", {
                            props: { type: "md-checkmark-circle-outline" },
                            attrs: {
                              title: "编辑",
                            },
                            on: {
                              click: (e) => {
                                that.clickUpdate(r);
                                e.stopPropagation();
                              },
                            },
                          }),
                          h("Icon", {
                            props: { type: "md-close" },
                            attrs: {
                              title: "删除",
                            },
                            on: {
                              click: (e) => {
                                that.delFleet(r);
                                e.stopPropagation();
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  );
                },
              };
            }
          });
          return d;
        }
        this.treeData = treedata(data);
      });
    },
    addUpdate() {
      let params = {
        name: this.userGroup.name,
        parentId: this.userGroup.parentId,
      };
      if (this.isAdd) {
        axios({
          method: "post",
          url: "/userGroup/add",
          data: params,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("新增成功");
            this.openGroup = false;
            this.getGroupList();
          } else {
            this.$Message.error(res.data.message);
          }
        });
      } else {
        params.groupId = this.userGroup.groupId;
        axios({
          method: "post",
          url: "/userGroup/update",
          data: params,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("编辑成功");
            this.openGroup = false;
            this.getGroupList();
          } else {
            this.$Message.error(res.data.message);
          }
        });
      }
    },
    clickOpenGroup() {
      this.openGroup = true;
      this.isAdd = true;
      this.userGroup.parentId = "";
      this.groupTitle = "新增一级单位";
    },
    //删除公司
    delFleet(row) {
      let params = {
        groupIdList: [row.groupId],
      };
      this.$Modal.confirm({
        title: "此操作将会导致主业务数据丢失，请确认是否进行删除操作？",
        cancelText: "取消删除",
        okText: "仍要删除",
        onOk: () => {
          axios({
            method: "post",
            url: "/userGroup/del",
            data: params,
          }).then((res) => {
            if (res.data.code != 200) {
              this.$Message.error(res.data.message);
            } else {
              this.$Message.success("删除成功");
              this.getGroupList();
            }
          });
        },
      });
    },
    clickAdd(r) {
      this.isAdd = true;
      this.openGroup = true;
      this.userGroup.parentId = r.groupId;
      this.groupTitle = "新增【" + r.name + "】下级单位";
      this.userGroup.name = "";
    },
    clickUpdate(r) {
      this.isAdd = false;
      this.openGroup = true;
      this.userGroup = r;
      this.userGroup.parentId = r.parentId == null ? "" : r.parentId;
      this.groupTitle = "编辑【" + r.name + "】";
    },
    cliclCancelBtn() {
      this.openGroup = false;
    },
    selectFleet(x, y) {
      this.$emit("group", y, x);
      this.grouopArr = x;
      ddd(this.treeData);
      function ddd(t) {
        for (const i in t) {
          t[i].checked = false;
          if (t[i].children) {
            ddd(t[i].children);
          }
        }
      }
    },
    //选择多个组
    selectAlot(x) {
      this.$emit("groups", x);
      ddd(this.treeData);
      function ddd(t) {
        for (const i in t) {
          t[i].selected = false;
          if (t[i].children) {
            ddd(t[i].children);
          }
        }
      }
    },
    queding() {
      this.$emit("queding", this.grouopArr);
    },
    quxiao() {},
    //监听外部搜索，比如车辆定位那里搜索
    look(key) {
      this.keyword = key;
      if (this.keyword.length > 0) {
        this.searchGroup();
      } else {
        this.getGroupList();
      }
    },
    searchGroup() {
      this.treeData = this.fineCurrentIdRecursive(this.treeData);
    },
    fineCurrentIdRecursive(list) {
      for (const i in list) {
        // if (list[i].id === this.currentId) {
        if (list[i].title.indexOf(this.keyword) != -1) {
          list[i].selected = true; //如果节点id等于currentId，则选中该节点
          setTimeout(() => {
            // var a = document.getElementById("box" + list[i].groupId).offsetTop;
            var a = document.getElementById("box" + list[i].groupId).offsetTop;
            document.getElementById("monitorTreeTop").scrollTop = a;
          }, 200);
          break;
        } else {
          list[i].expand = false;
          list[i].selected = false;
          list[i].children = this.fineCurrentIdRecursive(list[i].children); //找不到想要的节点则继续找孩子的（递归）
          for (const j in list[i].children) {
            if (list[i].children[j].selected || list[i].children[j].expand) {
              list[i].expand = true; //如果子节点（末端节点）选中或者子节点（非末端节点）展开，则展开该子节点的父节点
            }
          }
        }
      }
      return list;
    },
  },
  mounted() {
    this.getGroupList();
  },
};
</script>
<style lang="">
#treeWrap {
  height: 100%;
}
#monitorTreeTop {
  position: relative;
  top: 0;
  left: 0;
  overflow-x: hidden;
}
#treeWrap .treeHeight {
  height: calc(100%);
}
#treeWrap .treeHeight30 {
  height: calc(100% - 30px);
}
#treeWrap .treeHeight40 {
  height: calc(100% - 40px);
}
#treeWrap .treeHeight60 {
  height: calc(100% - 60px);
}
#treeWrap .treeHeight90 {
  height: calc(100% - 90px);
}
#treeWrap .treeHeight100 {
  height: calc(100% - 100px);
}
#treeWrap .treeHeight120 {
  height: calc(100% - 120px);
}
#treeWrap .treeHeight180 {
  height: calc(100% - 180px);
}
#treeBtn {
  padding: 20px;
}
.treeitem {
  min-width: 100px;
  height: 20px;
  position: relative;
}
.treeitem span {
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.treeitem:hover .control {
  width: 70px;
  
}
.treeitem .control {
  padding: 4px 0px 4px 4px;
  background: #fff;
  width: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: -4px;
  background: #fff;
  transition: width 0.6s, padding 0.6s;
}

.control i {
  font-size: 16px;
  margin-right: 6px;
  color: #468ffd;
}
/*提示框信息 */
#tooltip_ul {
  padding: 10px;
  line-height: 1;
}
#tooltip_ul li {
  margin-bottom: 10px;
}
#tooltip_ul li h3 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 0;
  color: #fff;
}
#tooltip_ul li p {
  margin-top: -4px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/common/groupTree.vue